export class SigningParams {
  signMethod: string = '';
  privateKeyType: string = '';
  signProvider: string = '';
  keyReaderType: string = '';
  validateKeyType: boolean = false;
  data: any = {};

  constructor(prms: {}) {
    this.init(prms);
  }
  private init(prms: {}): void {
    if (prms) {
      Object.keys(this).forEach(k => {
        if (k in prms) {
          this[k] = prms[k];
        }
      });
    }
  }
}

export class SigningParamsContainer {
  [privateKeyType: string]: SigningParams
}
